import { put, takeLatest } from 'redux-saga/effects'
import * as Eff from 'redux-saga/effects' // tslint:disable-line:no-duplicate-imports

import Logger from '@Utils/Logger'

import {
  IAction,
  ISuccessResponse,
} from '@Root/types'

import {
  CreditActionTypes,
  IStartCheckoutSessionPayload,
} from './types'

import {
  startCheckoutSessionFailure,
} from './actions'

import * as API from './api'

const call: any = Eff.call

interface IRedirectUri {
  readonly redirect_uri: string
}

function* startCheckoutSessionSaga(action: IAction<IStartCheckoutSessionPayload>) {
  try {
    const response: ISuccessResponse<IRedirectUri> = yield call(API.startCheckoutSession, action.payload)
    window.location.href = response.data.redirect_uri
  } catch (e) {
    Logger.error(e, 'Can\'t sell the credits')
    yield put(startCheckoutSessionFailure())
  }
}

function* creditSagas() {
  yield takeLatest(CreditActionTypes.START_CHECKOUT_SESSION, startCheckoutSessionSaga)
}

export default creditSagas
